import Container from "hardcover-ui/components/Container";
import { LetterbookSettingType } from "features/Letterbooks/types";
import LetterbooksControls from "./LetterbooksControls/LetterbooksControls";
import LetterbooksBooks from "./LetterbooksBooks/LetterbooksBooks";
import LetterbooksLoadingSkeleton from "./LetterbooksLoadingSkeleton/LetterbooksLoadingSkeleton";

interface LetterbookOptions {
  settings: LetterbookSettingType;
}

export default function LetterbooksWrapper({
  settings,
}: LetterbookOptions) {
  return (
    <Container size={settings.view === "table" ? "lg" : "sm"}>
      <LetterbooksControls settings={settings} />

      <LetterbooksLoadingSkeleton view={settings.view}>
        <LetterbooksBooks settings={settings} />
      </LetterbooksLoadingSkeleton>
    </Container>
  );
}
